import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../../../common/variables/translate-service";
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { GlobalService } from "../../../../common/services/global.service";
import { GlobalFunctionService } from "../../../../common/services/global-function.service";
import { Store } from '@ngrx/store';
import { planModified } from '../../../../store/senAppProjects.action';
import { SC_Input } from '../../../../common/input/SC_Input';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'sen-app-add-inverter',
  templateUrl: './add-inverter.component.html',
  styleUrls: ['./add-inverter.component.scss']
})
export class AddInverterComponent implements OnInit {
  selectedGen: any[] = [];
  allInverters$: Observable<any[]>;
  allInvertersUnSubscribe: Subscription;
  inverterSearchString: string;
  tempAllInverters: any[] = [];
  comboMissing: boolean = true;

  constructor(public dialogRef: MatDialogRef<AddInverterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public global: GlobalVariableService,
    private store: Store<any>,
    public globalService: GlobalService,
    public globalFunction: GlobalFunctionService
  ) {
    this.allInverters$ = this.store.select(state => { return state.appData.allInverters });
  }

  ngOnInit(): void {
    this.allInvertersUnSubscribe = this.allInverters$.subscribe(data => {
      data.forEach(item => {
        let i = {
          selected: false,
          times: undefined,
          inverter: item
        }
        this.tempAllInverters.push(i);
      })
    })
  }

  ngOnDestroy() {
    this.allInvertersUnSubscribe.unsubscribe();
  }

  closeDialogue(selectedGen?: any) {
    this.dialogRef.close(selectedGen);
  }

  calculateTotalPanel(g: any) {
    return g.inverter.maxPanel * g.times * g.inverter.mppt.length;
  }

  selectedSubGen(g: any) {
    this.tempAllInverters.forEach(item => {
      if (item.inverter.id != g.inverter.id) {
        item.selected = false;
        item.times = undefined;
      }
    });
    if (g.selected && typeof g.times == 'undefined') {
      g.times = 1;

    } else if (!g.selected || g.times < 1) {
      g.times = undefined;
      g.selected = false;
    }
    if (g.times) {
      g.totalPanels = this.calculateTotalPanel(g);
    }
    let a = this.tempAllInverters.filter(item => item.selected);
    let b = this.tempAllInverters.filter(item => item.times);
    if (a.length && a.length == b.length) {
      this.comboMissing = false;
      this.selectedGen = this.tempAllInverters.filter(item => item.selected && item.times);
    } else {
      this.comboMissing = true;
    }
  }

  filterInverter(event: any) {
    console.log(event.target.value);
  }
}

